
<div class="v-flex ">
    <div class="pt-1 pl-3 primary--text lm-border primary-border responsibility-area">
        {{ area }}
    </div>
    <div class="pl-2" style="width: 30%">
        <v-select
            class="pt-0"
            v-model        = "user"
            :items         = "responsibles"
            item-value     = "id"
            item-text      = "name"
            :return-object = "true"
            placeholder    = "Liftmanager"
            @change        = "onSelected"
            hide-details
            solo
            dense
        />
    </div>
</div>
